const $ = require('jquery');
const progress = require('../../utils/progress');
/**
 *
 */

const ALLOWED_NL_LOCALES = $('.js-allowed-locales').val() || '';

/**
 *
 */
const openForm = () => {
    $('.js-coming-soon-hidden').removeClass('hidden');
};

/**
 *
 */
const clearError = () => {
    $('.js-form-error').addClass('hidden');
};

/**
 * @param {string} error - error message
 */
const showError = error => {
    $('.js-form-error')
        .removeClass('hidden')
        .find('span')
        .html(error || '');
};

/**
 *
 */
const onLangCountryChange = () => {
    const country = $('.selector[id$="_country"]').find('select').val();
    const language = $('.selector[id$="_language"]').find('select').val();
    $('.js-accept-newsletter').toggleClass('hidden', !ALLOWED_NL_LOCALES.includes(`${language}_${country}`));
};

/**
 * @param {Array} allowedLanuages - a list of possible locales
 */
const renderLanguages = allowedLanuages => {
    $('.select-language option').each(function () {
        if (!$(this).val()) {
            return;
        }
        $(this).toggleClass('hidden', !allowedLanuages.includes($(this).val()));
    });
    $('.select-language')
        .val(allowedLanuages.length ? allowedLanuages[0] : '')
        .trigger('change');
};

/**
 *
 */
const checkFormFilling = () => {
    if (window.PerformanceNavigationTiming) {
        const navigationEntries = performance.getEntriesByType('navigation');
        if (navigationEntries.length > 0) {
            const navigationEntryType = navigationEntries[0].type;
            if (navigationEntryType === 'back_forward') {
                $('input').closest('.form-row').addClass('m-filled');
            }
        }
    }
};

/**
 * @param {Object} e - event
 */
const formSubmitEvent = e => {
    e.preventDefault();
    if ($('.js-coming-soon-hidden.hidden').length) {
        openForm();
        return;
    }
    clearError();
    const $comingSoon = $(e.target);
    if (!$('input[name$="_acceptcomingsoon"]').is(':checked')) {
        $comingSoon.one('submit', formSubmitEvent);
        showError($comingSoon.data('termsNotAcceptedMsg'));
        return;
    }
    $comingSoon.trigger('submit');
    progress.show();
};

/**
 *
 */
const initEvents = () => {
    const $comingSoonForm = $('#coming-soon-wrapper').find('form').first();

    $(window).on('load', checkFormFilling);
    $comingSoonForm.find('.js-comingsoon-email').one('focus click keyup', () => {
        openForm();
    });

    $('input[name$="_acceptcomingsoon"]').one('click', () => {
        clearError();
        $comingSoonForm.valid();
    });

    onLangCountryChange();

    $comingSoonForm.one('submit', formSubmitEvent);
    $('.select-language').on('change', onLangCountryChange);

    $('.select-country')
        .on('change', function () {
            const $currentTarget = $(this);
            const languageCodes = $('option:selected', $currentTarget).data('languagecodes');

            if (languageCodes) {
                renderLanguages(languageCodes);
                $currentTarget.uniform.update();
                onLangCountryChange();
            }
        })
        .trigger('change');
};

/* eslint-disable import/prefer-default-export */
/**
 * Initializes the coming soon page components and events.
 */
exports.init = () => {
    initEvents();
};
